import React from 'react';
import PropTypes from 'prop-types';

const IconButton = ({ children, iconClassName = '', onClick }) => (
  <div className="icon-button" onClick={onClick}>
    <span className={`icon-button__icon ${iconClassName}`} />
    <span className="icon-button__text">{children}</span>
  </div>
);

IconButton.propTypes = {
  children: PropTypes.node,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func
};

export default IconButton;
